import axios from 'axios';

const RPM_API_BASE_URL = "https://rpmapi.makebettinggreat.com/v1/";
const ANZ_API_BASE_URL = "https://anzapi.makebettinggreat.com/v1/"
const ENDPOINT_ODDS = ANZ_API_BASE_URL + 'horse/odds/';
const API_WINNER = RPM_API_BASE_URL + 'horse/winners/';
const API_VOLUME_MATCHED = RPM_API_BASE_URL + 'horse/volumematched/';
const ENDPOINT_REPORT_ALL = ANZ_API_BASE_URL +'race/detail/report/';
const ENDPOINT_ODDS_GPM = RPM_API_BASE_URL + 'horse/odds/';
const RACE_URL = ANZ_API_BASE_URL + "race/"
const RACE_DETAIL_URL = ANZ_API_BASE_URL + "track/"
const RACE_DETAIL_URL_2 = ANZ_API_BASE_URL + "race/detail/"

export const getAllReport = async (date) => {
    const url = ENDPOINT_REPORT_ALL + date
    const result = await axios.get(url)
    const data = result.data
    if (result.status === 200) {
        return data;
    } else {
        return []
    }
}

export const getRaceDetails = async (race) => {
    const url = RACE_DETAIL_URL + race.trackId + "/race/" + race.raceTime
    const result = await axios.get(url)
    const data = result.data
    if (result.status === 200) {
        return data;
    } else {
        return []
    }
}

export const getRaceSummary = async (race) => {
    const url = RACE_DETAIL_URL + race.trackId + "/race/" + race.raceTime + "/summary"
    const result = await axios.get(url)
    const data = result.data
    if (result.status === 200) {
        return data;
    } else {
        return []
    }
}

export const getAllRaceDetails = async (date) => {
    const url = RACE_DETAIL_URL_2 + date;
    const result = await axios.get(url)
    const data = result.data
    if (result.status === 200) {
        return data;
    } else {
        return []
    }
}

function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
    return [year, month, day].join('');
}

export const getAllRaces = async (date) => {
    const url = RACE_URL + date;
    const result = await axios.get(url)
    const data = result.data
    if (result.status === 200) {
        return data;
    } else {
        return []
    }
}
export const getRunnerOddsByMarketId = async (marketId, selectionId, dateStr) => {
    const year = parseInt(dateStr.substring(0, 4), 10);
    const month = parseInt(dateStr.substring(4, 6), 10) - 1; // months are 0-based
    const day = parseInt(dateStr.substring(6, 8), 10);
    const givenDate = new Date(year, month, day);

    const twoDaysAgo = new Date();
    twoDaysAgo.setDate(twoDaysAgo.getDate() - 2);

    let endpoint =  (givenDate < twoDaysAgo) ? ENDPOINT_ODDS : ENDPOINT_ODDS_GPM;
    const url = endpoint + marketId + "/" + selectionId;
    const result = await axios.get(url)
    const data = result.data
    if (result.status === 200) {
        return data;
    } else {
        return []
    }
}


export const getWinnerInfo = async (marketId, date, time) => {
    const endpoint = API_WINNER + date + "/" + time + "/" + marketId
    const result = await axios.get(endpoint)
    const data = result.data
    if (result.status === 200) {
        return data;
    } else {
        return []
    }
}

export const getVolumeMatched = async (marketId) => {
    const endpoint = API_VOLUME_MATCHED + marketId
    const result = await axios.get(endpoint)
    const data = result.data
    if (result.status === 200) {
        return data;
    } else {
        return []
    }
}

export const getMatchesByDate = async date => {
    return []
}